function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { DashboardUtils, LazyDashboard } from '@deephaven/dashboard';
import { useObjectFetcher } from '@deephaven/jsapi-bootstrap';
import { LoadingOverlay } from '@deephaven/components';
import { jsx as _jsx } from "react/jsx-runtime";
export function AppDashboards(_ref) {
  var dashboards = _ref.dashboards,
    activeDashboard = _ref.activeDashboard,
    onLayoutInitialized = _ref.onLayoutInitialized,
    onGoldenLayoutChange = _ref.onGoldenLayoutChange,
    plugins = _ref.plugins,
    _ref$emptyDashboard = _ref.emptyDashboard,
    emptyDashboard = _ref$emptyDashboard === void 0 ? /*#__PURE__*/_jsx(LoadingOverlay, {
      "data-testid": "app-dashboards-loading"
    }) : _ref$emptyDashboard;
  var fetchObject = useObjectFetcher();
  var hydratePanel = useCallback((hydrateProps, id) => {
    var metadata = hydrateProps.metadata;
    try {
      if (metadata != null) {
        return _objectSpread(_objectSpread({
          fetch: function () {
            var _fetch = _asyncToGenerator(function* () {
              return fetchObject(metadata);
            });
            function fetch() {
              return _fetch.apply(this, arguments);
            }
            return fetch;
          }()
        }, hydrateProps), {}, {
          localDashboardId: id
        });
      }
    } catch (e) {
      // Ignore being unable to get the variable descriptor, do the default dashboard hydration
    }
    return DashboardUtils.hydrate(hydrateProps, id);
  }, [fetchObject]);
  return /*#__PURE__*/_jsx("div", {
    className: "tab-content",
    children: dashboards.map(d => /*#__PURE__*/_jsx("div", {
      className: classNames('tab-pane', {
        active: d.id === activeDashboard
      }),
      children: /*#__PURE__*/_jsx(LazyDashboard, {
        id: d.id,
        isActive: d.id === activeDashboard,
        emptyDashboard: emptyDashboard,
        layoutConfig: d.layoutConfig,
        layoutSettings: d.layoutSettings,
        onLayoutInitialized: onLayoutInitialized,
        onGoldenLayoutChange: onGoldenLayoutChange,
        hydrate: hydratePanel,
        plugins: plugins
      }, d.key)
    }, d.id))
  });
}
export default AppDashboards;
//# sourceMappingURL=AppDashboards.js.map